import { Injectable } from '@angular/core';
import { ColorField, ImageField, KeyTextField, PrismicDocument, RichTextField } from '@prismicio/client';
import { LinkField, SelectField } from '@prismicio/types';
import { from, Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class TenantService {
    private static TYPE: 'tenant' = 'tenant';

    getTenant(uid: string): Observable<PrismicDocument<Tenant>> {
        return from(environment.prismic.client.getByUID<PrismicDocument<Tenant>>(TenantService.TYPE, uid));
    }
}

export type Tenant = {
    page_title: string;
    meta_description: string;
    name: KeyTextField;
    color: ColorField;
    logo: ImageField;
    title: RichTextField;
    text: RichTextField;
    imprint: LinkField;
    data_policy: LinkField;
    personal_data_title: RichTextField;
    personal_data_description: RichTextField;
    organization_type: SelectField;
    contact_person: SelectField;
    custom_entry_html?: KeyTextField;
};

export const accadisUID = 'c3a81592-ff85-48b4-afa8-1a5acc32aeed';
export const dfbUIDs = ['76b8b544-6b30-4ce2-8d28-38e00b0b3350', '7414d379-476b-4740-a4e5-4101a2414308'];
